import React, { useEffect, useState } from 'react'
import WebComponentContainer from '../generic/WebComponentContainer'
// import useEventBus from '../generic/useEventBus'

export default ({ vehicleName, trim, vin, currentStep, pages, stepClick, mileage }) => {
  const [pageLoaded, setPageLoaded] = useState(false)
  const [showLoader, setShowLoader] = useState(false)

  useEffect(() => {
    setPageLoaded(true)
  }, [])

  useEffect(() => {
    setShowLoader(false)
  }, [])

  return (
    <WebComponentContainer pageLoadingComplete={pageLoaded} withLoader={showLoader} maxWidth="100%" location={'breadcrumb'}>
      <yes-its-perfect-modal />
    </WebComponentContainer>
  )
}
